import React, { useEffect } from "react";
import Pages from "components/common/Pages";
import Details from "components/Pages/Transactions/Details";
import DisputeFlow from "components/Pages/Transactions/DisputeFlow";
import DisputeFlowInternal from "components/Pages/Transactions/DisputeFlowInternal";
import DisputeSuccess from "components/Pages/Transactions/DisputeSuccess";

const DisputeOverlay = ({
  closeOverlay,
  submitDispute,
  disputeReasons,
  addTransactionTags,
  removeTransactionTag,
  row,
  user,
  internal = false
}) => {
  useEffect(() => {
    const launcher = document.getElementById("launcher") || {};
    (launcher.style || {}).bottom = "130px";
    return () => {
      (launcher.style || {}).bottom = "80px";
    };
  }, []);

  const DisputeComponent = internal ? DisputeFlowInternal : DisputeFlow;

  return (
    <div
      className="pt-6 pb-8 px-12 h-full overflow-auto"
      style={{ backgroundColor: "#FAFAFA" }}
    >
      <Pages>
        <Details
          row={row}
          close={closeOverlay}
          addTransactionTags={addTransactionTags}
          removeTransactionTag={removeTransactionTag}
        />
        <DisputeComponent
          data={{ user, transaction: { ...row.original } }}
          row={row}
          close={closeOverlay}
          submitDispute={submitDispute}
          reasons={disputeReasons}
        />
        <DisputeSuccess close={closeOverlay} />
      </Pages>
    </div>
  );
};

export default DisputeOverlay;
